<main>
@if( cognitoService.hasStoredCredentials ) {  
  @if( user ) { <h2>Welcome, {{user.user_id}}!</h2> }

  <mat-card>
    <mat-card-header>
      <mat-card-title>Get started or jump back in</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-nav-list>
        <a mat-list-item routerLink='/workspace'>
          <mat-icon matListItemIcon>build</mat-icon>
          <span matListItemTitle>Go to your workspace</span>
          <span matListItemDescription>...to start entering glosses</span>
        </a>
        <mat-list-item (click)="commonTasks.newProject()">
            <mat-icon matListItemIcon>add</mat-icon>
            <span matListItemTitle>Start a new project...</span>
        </mat-list-item>
        <a mat-list-item routerLink='/join'>
          <mat-icon matListItemIcon>group_add</mat-icon>
          <span matListItemTitle>Join an existing project...</span>
        </a>
        <a mat-list-item target="_blank" href="https://docs.openreadersbibles.org/">
          <mat-icon matListItemIcon>menu_book</mat-icon>
          <span matListItemTitle>Read the documentation</span>
        </a>
      </mat-nav-list>
    </mat-card-content>
  </mat-card>
} @else {

  <mat-card>
    <mat-card-header>
      <mat-card-title>Welcome!</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>This is a website that allows you to make reader's Bibles in your own language. A reader's Bible is an edition of the Greek or Hebrew Bible that helps readers with parsings, and with the definitions of rarer words. Usually that would be a lot of work, but this website takes care of the difficult parts for you.</p>
      <mat-nav-list>
        <mat-list-item (click)="signUpConfirmation()">
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>Create your free account right now!</span>
        </mat-list-item>
        <a mat-list-item target="_blank" href="https://docs.openreadersbibles.org/">
          <mat-icon matListItemIcon>menu_book</mat-icon>
          <span matListItemTitle>Read the documentation</span>
          <span matListItemDescription>...to get an overview of process</span>
        </a>
      </mat-nav-list>
    </mat-card-content>
  </mat-card>   
}

<app-highlighted-projects></app-highlighted-projects>
</main>
